import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import SidebarMenuItem, { SidebarMenuItemProps } from './SidebarMenuItem';

interface MenuListItem extends Omit<SidebarMenuItemProps, 'isLast' | 'isFirst'> {}

interface Props {
  items: MenuListItem[];
}

const SidebarMenuList: FC<Props> = ({ items }) => {
  return (
    <Flex direction="column">
      {items.map((item, index) => {
        return (
          <SidebarMenuItem
            key={index}
            {...item}
            isLast={index === items.length - 1}
            isFirst={index === 0}
          />
        );
      })}
    </Flex>
  );
};

export default SidebarMenuList;
